// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"148ba4a2","66":"9b90a597","211":"148ba4a2","495":"148ba4a2","715":"148ba4a2","744":"148ba4a2","947":"be77114e"}[chunkId] + ".chunk.css";
};